/* Enhance the native Judge.me widget without replacing its review data or controls. */
(function () {
  'use strict';
  function build(frame) {
    if (frame.dataset.mgEditorialReady) return;
    frame.dataset.mgEditorialReady = '1';
    var sequence = 0, queued = false;
    function enhance() {
      frame.querySelectorAll('.jm-shop-reply').forEach(function (reply) {
        if (reply.querySelector('.mg-review-reply-toggle')) return;
        var author = reply.querySelector('.jm-shop-reply__author');
        var content = reply.querySelector('.jm-shop-reply-content');
        if (!author || !content) return;
        var label = author.textContent.trim().replace(/[:：]$/, '');
        if (!label) return;
        sequence += 1;
        content.id = content.id || 'mg-review-reply-' + frame.querySelector('[data-product-id]').dataset.productId + '-' + sequence;
        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'mg-review-reply-toggle';
        toggle.textContent = label;
        toggle.setAttribute('aria-label', label);
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', content.id);
        reply.classList.add('mg-review-reply');
        reply.classList.remove('is-open');
        reply.insertBefore(toggle, author);
        toggle.addEventListener('click', function () {
          var open = toggle.getAttribute('aria-expanded') !== 'true';
          reply.classList.toggle('is-open', open);
          toggle.setAttribute('aria-expanded', String(open));
        });
      });
      frame.querySelectorAll('.jm-average-rating-display > .jm-cluster').forEach(function (cluster) {
        var score = cluster.querySelector('.jm-text');
        if (!score) return;
        var rating = Number(score.textContent.trim().replace(',', '.'));
        if (!Number.isFinite(rating) || rating < 0 || rating > 5) return;
        var stars = cluster.querySelector('.mg-review-summary-stars');
        if (!stars) {
          stars = document.createElement('span');
          stars.className = 'mg-review-summary-stars';
          stars.textContent = '★★★★★';
          stars.setAttribute('aria-hidden', 'true');
          score.insertAdjacentElement('afterend', stars);
        }
        stars.style.setProperty('--mg-rating-fill', (rating / 5 * 100) + '%');
      });
    }
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; enhance(); });
    });
    observer.observe(frame, { childList:true, subtree:true, characterData:true });
    enhance();
  }
  function init(root) {
    root.querySelectorAll('.mgp__reviews-frame').forEach(build);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
